import { createFeatureSelector } from '@ngrx/store';
import { PaceOfflineFeatureState } from '../state';

export const selectOfflineFeature = createFeatureSelector<PaceOfflineFeatureState>('paceOffline');
